import React from "react";
import { IonSkeletonText } from "@ionic/react";
import ProductCardSkeleton from "../../../components/UI/ProductCardSkeleton/ProductCardSkeleton";

const productsSkeleton = [...Array(8).keys()];
const categoriesSkeleton = [...Array(6).keys()];
const additionalFeaturesSkeleton = [...Array(4).keys()];

const SubcategoriesSkeleton = () => {
  return (
    <div className="flex flex-col gap-2.5">
      <div className="flex flex-wrap justify-center items-center gap-1.5 px-5">
        {categoriesSkeleton.map((skelet) => {
          return <IonSkeletonText key={skelet} className="w-[7.5rem] h-[9.375rem] rounded-lg m-0" animated />;
        })}
      </div>

      <IonSkeletonText animated className="w-32 h-8 ml-5" />

      <div className="flex items-center gap-2.5 px-5 overflow-hidden">
        {additionalFeaturesSkeleton.map((skelet) => {
          return <IonSkeletonText key={skelet} animated className="w-32 h-7" />;
        })}
      </div>

      <div className="flex flex-col gap-2.5 p-5">
        <div className="grid grid-cols-2 lg:flex lg:flex-wrap md:flex md:flex-wrap xs:flex xs:flex-wrap justify-center gap-y-2.5 gap-x-2.5 ">
          {productsSkeleton.map((skelet) => {
            return <ProductCardSkeleton key={skelet} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default SubcategoriesSkeleton;
